module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-banner-ni.8c67be36.png";